import { useState } from 'react';
import { useAppStore } from '../../stores/appStore';
import { notesApi } from '../../lib/api';

export function TodosWidget() {
  const todos = useAppStore((s) => s.todos);
  const users = useAppStore((s) => s.users);
  const user = useAppStore((s) => s.user);
  const refresh = useAppStore((s) => s.refreshWidgetsData);
  const [title, setTitle] = useState('');

  async function add() {
    if (!title.trim() || !user) return;
    await notesApi.createTodo({ title: title.trim(), category: 'chores' });
    setTitle('');
    await refresh();
  }

  async function toggle(id: string, done: boolean) {
    if (!user) return;
    await notesApi.updateTodo(id, { done: !done });
    await refresh();
  }

  async function remove(id: string) {
    if (!user) return;
    await notesApi.deleteTodo(id);
    await refresh();
  }

  const nameOf = (id: string | null) =>
    users.find((u) => u.id === id)?.name || null;

  return (
    <div className="flex h-full flex-col">
      <h3 className="mb-2 text-sm font-bold uppercase tracking-wide text-slate-400">
        To-do / chores
      </h3>
      <ul className="flex-1 space-y-1.5 overflow-auto">
        {todos.map((t) => (
          <li
            key={t.id}
            className="group flex items-center gap-2 rounded-lg bg-slate-800/50 px-2 py-1.5 light:bg-slate-100"
          >
            <button
              type="button"
              onClick={() => void toggle(t.id, Boolean(t.done))}
              className={`flex h-5 w-5 shrink-0 items-center justify-center rounded border ${
                t.done
                  ? 'border-emerald-500 bg-emerald-500 text-white'
                  : 'border-slate-500'
              }`}
            >
              {t.done ? '✓' : ''}
            </button>
            <span
              className={`min-w-0 flex-1 text-sm ${
                t.done ? 'text-slate-500 line-through' : ''
              }`}
            >
              {t.title}
              {t.assignee_id && (
                <span className="ml-1 text-xs text-slate-500">
                  · {nameOf(t.assignee_id)}
                </span>
              )}
            </span>
            <button
              type="button"
              className="hidden text-xs text-red-400 group-hover:block"
              onClick={() => void remove(t.id)}
            >
              ×
            </button>
          </li>
        ))}
        {todos.length === 0 && (
          <li className="text-sm text-slate-500">All clear ✨</li>
        )}
      </ul>
      {user && (
        <div className="mt-2 flex gap-1">
          <input
            className="min-w-0 flex-1 rounded-lg border border-slate-600 bg-slate-800 px-2 py-1.5 text-sm outline-none focus:border-violet-500"
            placeholder="Add chore…"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && void add()}
          />
          <button
            type="button"
            onClick={() => void add()}
            className="rounded-lg bg-violet-600 px-3 py-1 text-sm font-bold text-white"
          >
            Add
          </button>
        </div>
      )}
    </div>
  );
}
